export default "__VITE_ASSET__BTuj37ML__"